import { HttpClient, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './service-base';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./context.service";
export class IqaService extends ServiceBase {
    constructor(http, contextService) {
        super(contextService);
        this.http = http;
    }
    getQueryColumns(queryPath) {
        let headers = this.getHeaders();
        let url = this.getUrl('QueryDefinition/_execute');
        let findBypath = {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "FindByPath",
            "EntityTypeName": "QueryDefinition",
            "Parameters": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
                "$values": [
                    {
                        "$type": "System.String",
                        "$value": queryPath //particular query.
                    }
                ]
            },
            "ParameterTypeName": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
                "$values": [
                    "System.String"
                ]
            },
            "UseJson": false
        };
        return this.http.post(url, findBypath, { headers: headers }).pipe(map((res) => {
            return res.Result.Properties.$values.map((x) => x.PropertyName);
        }));
    }
    getQueryParameters(queryPath) {
        let headers = this.getHeaders();
        let url = this.getUrl('QueryDefinition/_execute');
        let findBypath = {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "FindByPath",
            "EntityTypeName": "QueryDefinition",
            "Parameters": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
                "$values": [
                    {
                        "$type": "System.String",
                        "$value": queryPath //particular query.
                    }
                ]
            },
            "ParameterTypeName": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib",
                "$values": [
                    "System.String"
                ]
            },
            "UseJson": false
        };
        // console.log("iqa &&&&&&&&&&&&&&&&&&&&&&&&&&&")
        return this.http.post(url, findBypath, { headers: headers }).pipe(map((res) => {
            return res.Result.Parameters.$values.map((x) => x.PropertyName);
        }));
    }
    getIqaResults(queryPath, parameters) {
        const headers = this.getHeaders();
        const params = new HttpParams().set('QueryName', queryPath);
        const url = this.getUrl('iqa');
        parameters.forEach((value, key) => {
            params.set('parameter', value);
        });
        return this.http.get(url, { params, headers }).pipe(map((res) => res)).pipe(catchError(this.handleError));
    }
}
IqaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IqaService_Factory() { return new IqaService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ContextService)); }, token: IqaService, providedIn: "root" });
